import { Box } from "@mui/material";
import theme from "theme";
import { Row } from "v2/components/base/Flex/ui";

const Stepper = ({ slide, totalSlides }: { slide: number; totalSlides: number }) => {
  return (
    <Row
      sx={{
        gap: "16px",
        padding: "12px 0 16px",
      }}>
      {[...Array(totalSlides)].map((_, pageIndex) => (
        <Box
          sx={{
            border: `1px solid ${theme.palette.border.dark}`,
            borderRadius: "50%",
            width: "12px",
            height: "12px",
            background:
              slide === pageIndex ? theme.palette.brand.primary : theme.palette.surface.silver,
          }}
        />
      ))}
    </Row>
  );
};

export default Stepper;
